import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["agent", "date", "time", "duration", "slots", "slotsEmpty"]
  static values = {
    url: String,
    connected: Boolean,
    listingId: String
  }

  connect() {
    if (!this.connectedValue) return

    this.onInquirySelected = this.onInquirySelected.bind(this)
    this.element.addEventListener("viewing-inquiry:selected", this.onInquirySelected)
    this.refresh()
  }

  disconnect() {
    this.element.removeEventListener("viewing-inquiry:selected", this.onInquirySelected)
  }

  onInquirySelected(event) {
    const listingId = event.detail?.listingId
    if (!listingId) return

    this.listingIdValue = listingId
    this.refresh()
  }

  refresh() {
    if (!this.connectedValue || !this.hasDateTarget) return

    const date = this.dateTarget.value
    if (!date) return

    const params = new URLSearchParams({ date })
    if (this.hasAgentTarget && this.agentTarget.value) {
      params.set("assigned_pro_user_id", this.agentTarget.value)
    }
    if (this.hasDurationTarget && this.durationTarget.value) {
      params.set("duration_minutes", this.durationTarget.value)
    }
    if (this.hasListingIdValue && this.listingIdValue) {
      params.set("listing_id", this.listingIdValue)
    }

    fetch(`${this.urlValue}?${params.toString()}`, {
      headers: { Accept: "application/json" }
    })
      .then((response) => response.json())
      .then((payload) => this.renderSlots(payload.slots || []))
      .catch(() => this.renderSlots([]))
  }

  pick(event) {
    event.preventDefault()
    if (!this.hasTimeTarget) return

    this.timeTarget.value = event.currentTarget.dataset.time
    this.slotsTarget.querySelectorAll("button").forEach((button) => {
      button.classList.toggle("pro-viewing-slot-chip--active", button === event.currentTarget)
    })
  }

  renderSlots(slots) {
    if (!this.hasSlotsTarget) return

    this.slotsTarget.innerHTML = ""
    if (slots.length === 0) {
      if (this.hasSlotsEmptyTarget) this.slotsEmptyTarget.hidden = false
      return
    }

    if (this.hasSlotsEmptyTarget) this.slotsEmptyTarget.hidden = true

    slots.forEach((slot) => {
      const button = document.createElement("button")
      button.type = "button"
      button.className = "pro-viewing-slot-chip"
      button.dataset.time = slot.time
      button.dataset.action = "viewing-slots#pick"
      button.textContent = slot.label
      this.slotsTarget.appendChild(button)
    })
  }
}
